module.exports = __webpack_public_path__ + "img/img_battery_rear.4e442e96.jpg";